var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"name",class:_vm.styles.name(_vm.point, _vm.selected),on:{"click":_vm.clickHandler}},[_vm._v("\n    "+_vm._s(_vm.point.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }